<h1 mat-dialog-title class="{{ 'mat-dialog-title ' + data.type }}">{{ data.title }}</h1>
<div mat-dialog-content>
  <p [style]="data.style" [innerHTML]="data.text"></p>
  <br *ngIf="data.link" />
  <a [href]="data.link" *ngIf="data.link">{{ data.link }}</a>
  <pre *ngIf="data.json">{{ data.json | json }}</pre>
  <pre *ngIf="data.pre">{{ data.pre }}</pre>
</div>
<div mat-dialog-actions class="mb-3">
  <button class="btn btn-primary" (click)="closeDialog()">Ok</button>
</div>
